export default __webpack_public_path__ + "static/media/simple-logo.ce6fe05b.svg";